import { useEffect, useRef, useState } from 'react';
import { throttle } from 'lodash';
import { useApplicationState } from '@apollo/core';

/**
 * Hook that detect the scrolling of the main page container
 */
const useScrollPage = () => {
  const [isScroll, setIsScroll] = useState(false);
  const { layout } = useApplicationState();
  const scrollEndTimer = useRef(null);

  const handleScrollEnd = () => {
    setIsScroll(false);
  };

  const handleScroll = throttle(() => {
    setIsScroll(true);
    clearTimeout(scrollEndTimer);
    scrollEndTimer.current = setTimeout(handleScrollEnd, 100);
  }, 300);

  useEffect(() => {
    if (!layout.mobileDevice) {
      document.querySelector('.main__page')?.addEventListener('scroll', handleScroll);
    } else {
      document.addEventListener('scroll', handleScroll);
    }

    return () => {
      if (!layout.mobileDevice) {
        document.querySelector('.main__page')?.removeEventListener('scroll', handleScroll);
      } else {
        document.removeEventListener('scroll', handleScroll);
      }
    };
  }, [layout]);

  return isScroll;
};

export default useScrollPage;
